export default __webpack_public_path__ + "b04754ec3c15903c4345be799f3b203e.png";